import React from 'react';

// Types
import { UpdateAiTemplateSectionType } from 'Shared/types/UpdateAiTemplate.type';

// Components
import PromptSection from './PromptSection';

type Props = {
  section: UpdateAiTemplateSectionType;
  number: number;
  handleRegerateSection: Function;
};
const TemplateSectionItem = ({ section, number, handleRegerateSection }: Props) => {
  const baseClassName = 'TemplateSectionItem';

  return (
    <div className={baseClassName}>
      <PromptSection section={section} number={number} handleRegerateSection={handleRegerateSection} />
    </div>
  );
};

export default TemplateSectionItem;
